import { PageInfo } from "./page.info.model";
import { SortInfo } from "./sort.info.model";


export class PermissionGridRequestModel {
    SortInfo: SortInfo = new SortInfo();
    PageInfo: PageInfo = new PageInfo();
    SearchText: string = '';
}